import { BusinessDownloadConfig } from '../types';
import { ECHARTS_DATASOURCE_METRICS_FOLLOWING } from '@/pages/intelligence/utils/constant';
import { publisherCheckboxList } from './common';

// following 页不展示，PC/PC&Console 页新增的 stream_id 字段
const followingPublisherCheckboxList = {
  ...publisherCheckboxList,
  defaultValue: {
    ...publisherCheckboxList.defaultValue,
    steam_id_show: undefined,
  },
  options: publisherCheckboxList?.options?.slice(0, -1),
};

const followingConfig: BusinessDownloadConfig = {
  'following-currentgame-mobile': {
    apiUrl: 'api/v1/intelligence_pc/following/mobile/current_games/download_excel',
    translate: true,
    formList: [
      {
        className: 'dbi-top-companies-source-metric-selector',
        label: 'dbi_label_metrics',
        type: 'followingMetric',
        field: 'metrics',
        defaultValue: [
          'appannie_au',
          'appannie_rv',
          'appannie_dl',
          'sensortower_au',
          'sensortower_rv',
          'sensortower_dl',
          'stream_hw',
          'stream_pk',
        ],
        cascadeOptions: ECHARTS_DATASOURCE_METRICS_FOLLOWING,
      },
      {
        label: 'dbi_retention',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['D2', 'D3', 'D7', 'D15', 'D31'],
        options: [
          { label: 'D2', value: 'D2' },
          { label: 'D3', value: 'D3' },
          { label: 'D7', value: 'D7' },
          { label: 'D15', value: 'D15' },
          { label: 'D31', value: 'D31' },
        ],
      },
      followingPublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            message: 'dbi_label_time_settings_tips',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: '',
            type: 'checkboxGroup',
            field: 'download_date_type',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            defaultValue: ['daily'],
            options: [
              { label: 'dbi_daily', value: 'daily' },
              { label: 'dbi_weekly', value: 'weekly' },
              { label: 'dbi_monthly', value: 'monthly' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
    bubbleText: '',
  },
  'following-currentgame': {
    apiUrl: 'api/v1/intelligence_pc/following/pconsole/current_games/downloads_excel',
    translate: true,
    formList: [
      {
        className: 'dbi-top-companies-source-metric-selector',
        label: 'dbi_label_metrics',
        type: 'followingMetric',
        field: 'metrics',
        defaultValue: [
          'appannie_au',
          'appannie_rv',
          'appannie_dl',
          'sensortower_au',
          'sensortower_rv',
          'sensortower_dl',
          'stream_hw',
          'stream_pk',
        ],
        cascadeOptions: ECHARTS_DATASOURCE_METRICS_FOLLOWING,
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'time_method',
            message: '',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
        ],
      },
    ],
    bubbleText: '',
  },
  'following-newgame': {
    apiUrl: 'api/v1/intelligence_pc/following/new_game/downloads_excel',
    translate: true,
    formList: [
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'time_method',
            message: '',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
        ],
      },
    ],
    bubbleText: '',
  },
  'following-newcompany': {
    apiUrl: 'api/v1/intelligence_pc/following/new_companies/download',
    translate: true,
    formList: [
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'time_method',
            message: '',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
        ],
      },
    ],
    bubbleText: '',
  },
};

export default followingConfig;
